import React from 'react';
import { connect } from 'react-redux';
import { HashRouter, Router, Route, Switch, Link, NavLink } from 'react-router-dom';
import createHistory from 'history/createBrowserHistory';
import DashboardPage from '../components/DashboardPage/DashboardPage';
import NotFoundPage from '../components/NotFoundPage';
import LoginPage from '../components/LoginPage/LoginPage';
import MemoryChargedLoginPage from '../components/MemoryChargedLoginPage/MemoryChargedLoginPage';
import PrivateRoute from './PrivateRoute';
import PublicRoute from './PublicRoute';
import ProfilPage from '../components/ProfilPage/ProfilPage';
import AssistanceAgreementPage from '../components/AssistanceAgreementPage/AssistanceAgreementPage';
import MemoryChargedPage from '../components/MemoryChargedPage/MemoryChargedPage';
import LegalInformationPage from '../components/LegalInformationPage/LegalInformationPage';
import Obituary from '../components/ObituaryPage/ObituaryPage';
import FuneralPage from '../components/FuneralPage/FuneralPage';
import SignOnPage from '../components/SignOnPage/SignOnPage';
import ResetPasswordPage from '../components/LoginPage/ResetPasswordPage';
import MemoryChargedResetPasswordPage from '../components/MemoryChargedLoginPage/MemoryChargedResetPasswordPage';
import ValidationPage from '../components/SignOnPage/ValidationPage';
import RecapPage  from '../components/Recap/RecapPage';
import LegalNoticePage  from '../components/LegalNotice/LegalNoticePage';
import ActivationAccountPage from '../components/ActivateAccount/ActivateAccountPage';
import ReactivationBenefPage from '../components/ReactivationPage/ReactivationBenefPage';
import ReactivationChargePage from '../components/ReactivationPage/ReactivationChargePage';
import cookielaw from '../utils/cookielaw';
import '../utils/expireSession' ;

export const history = createHistory();

class AppRouter extends React.Component {
  render() {

    cookielaw(this.props.partenaireData);

    return (
    <HashRouter basename={process.env.PUBLIC_URL}>
      <div className="container root">
        <Switch>
          <PublicRoute path="/" component={LoginPage} exact={true} />
          <PublicRoute path="/charge-memoire-login" component={MemoryChargedLoginPage}  />
          <PublicRoute path="/reset/:user" component={ResetPasswordPage}  />
          <PublicRoute path="/charge-memoire-reset/:user" component={MemoryChargedResetPasswordPage}  />
          <PublicRoute path="/activation/:user" component={ActivationAccountPage}  />
          <PublicRoute path="/sinscrire" component={SignOnPage} />
          <PublicRoute path="/confirmation/:user" component={ValidationPage} />
          <PublicRoute path="/reactivation/:user" component={ReactivationBenefPage} />
          <PublicRoute path="/reactivation-charge-memoire/:user" component={ReactivationChargePage} />
          <PrivateRoute path="/accueil" component={DashboardPage} />
          <PrivateRoute path="/profil" component={ProfilPage} />
          <PrivateRoute path="/convention-obseques" component={AssistanceAgreementPage} />
          <PrivateRoute path="/charges-de-memoire" component={MemoryChargedPage} />
          <PrivateRoute path="/informations-juridiques" component={LegalInformationPage} />
          <PrivateRoute path="/avis-deces" component={Obituary} />
          <PrivateRoute path="/mes-obseques" component={FuneralPage} />
          <PrivateRoute path="/recap-recueil" component={RecapPage} />
          <PrivateRoute path="/cgu/:id" component={LegalNoticePage} />
          <PublicRoute path="/public-cgu/:id" component={LegalNoticePage} />
          <Route component={NotFoundPage} />
        </Switch>
      </div>
    </HashRouter> );
  }
}

const mapStateToProps = state => {
  return {
    partenaireData: state.partenaireData,
  }
}

export default connect(mapStateToProps)(AppRouter);



// WEBPACK FOOTER //
// ./src/routers/AppRouter.js